<template>
    <div
    class="modal right fade trader-info"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <div>
                <h5 class="modal-title" v-if="!commissionData">Add Commission</h5>
                <h5 class="modal-title" v-if="commissionData">Edit Commission</h5>
            </div>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="inputEmail4">Commission Name</label>
                        <input  type="text" class="form-control" id="inputEmail4" placeholder="Commission name"  v-model="commissionName" >
                    </div>
                </div>  
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <p v-if="errors.length">
                    <ul>
                    <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                </p>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <button v-if="!commissionData"  :disabled="!commissionName" type="button" class="btn btn-primary" @click="addCommission()">ADD</button>
                    <button v-if="commissionData" :disabled="!commissionName" type="button" class="btn btn-primary" @click="updateCommission()">UPDATE</button>
                </div>
            </form>
        </div>
        </div>
    </div>
    </div>
</template>

    <script>
    import authService from "@/authService";
    import config from "@/config";

    export default {
        name: 'commissionAddmodal',
        components :{
            
        },
        props: ['commissionData'],
        data() {
            return {
                loading : false,
                errors: [],
                commissionName : ""
            };
        },
        methods: {   
            addCommission(){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .post(
                    config.baseUrlBidSide +
                    "/pnl/commissions",
                    {"commissionName":this.commissionName,"isFallback ":false},
                    auth
                )
                .then(() => {
                    this.$alert("Commission added successfully","","success");
                    this.loading = false;
                    this.$emit('close');               

                }).catch(() => this.loading = false) 
            },
            updateCommission(){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .put(
                    config.baseUrlBidSide +
                    "/pnl/commissions",
                    {"id":this.commissionData.id,"commissionName":this.commissionName,"isFallback":false},
                    auth
                )
                .then(() => {
                    this.$alert("Commission updated successfully","","success");
                    this.loading = false;
                    this.$emit('close');               

                }).catch(() => this.loading = false) 
            }
        },
        mounted(){
            if(this.commissionData) this.commissionName = this.commissionData.commissionName
            console.log(this.commissionData)
        }
    };
    </script>